angular.module('cvsApp')
  .filter("lastFour", function () {
    return function (str) {
      if (str) {
        var a = str + "";
        return a.substring(a.length - 4);
      }
      return "";
    };
  })
  .filter("friendlyMopLabel", function () {
    return function (method) {
      var label = "Account";
      switch (method) {
        case 'CCARD':
          label = "Credit Card";
          break;
        case 'CHECK':
          label = "Bank Account";
          break;
        default:
          label = "Account";
      }
      return label;
    };
  })
  .filter("friendlyTnxLabel", function () {
    return function (type) {
      var label = "Account";
      switch (type) {
        case 'PAYMENT':
          label = "Payment for";
          break;
        case 'CHARGE':
          label = "Charge";
          break;
        default:
          label = "Adjustment";
      }
      return label;
    };
  })
  .filter("monthRange", function () {
    return function (input, month, direction) {
      var filtered = [];
      if (month == "") return input;
      var index = _.findIndex(input, month);
      if (direction == "to") {
        filtered = input.slice(index);
      } else if (direction == "from") {
        filtered = input.slice(0, index);
      }
      return filtered;
    };
  })
  .filter("customDateFilter", function () {
    return function (items, from, to) {
      function parseDate(input) {
        var parts = input.split('-');
        return new Date(parts[2], parts[1] - 1, parts[0]);
      }
      var df = parseDate(from);
      var dt = parseDate(to);
      var result = [];
      for (var i = 0; i < items.length; i++) {
        var tf = new Date(items[i].date1 * 1000),
          tt = new Date(items[i].date2 * 1000);
        if (tf > df && tt < dt) {
          result.push(items[i]);
        }
      }
      return result;
    };
  })
  .filter("rounded", function () {
    return function (val, to) {
      return Math.ceil(val * 100) / 100;
    }
  })
  .filter('formatRefId', function () {
    return function (data, length) {
      if (data == -1) { //-1 is returned for Network errors hence a check for it
        return '-1';
      }
      if (data && data.trim() !== '') {
        // if(data == -1){//-1 is returned for Network errors hence a check for it
        //   return '-1';
        // }else{
        var strColl = data.split('-');
        var ptrStr = '.{1,' + length + '}';
        var ptrn = new RegExp(ptrStr, 'g');
        var strDashcal = strColl[strColl.length - 1].match(ptrn);
        var dshStr = strDashcal.join('-');
        dshStr = dshStr.substring(0, 15);
        return dshStr;
        // }
      }
      return 'Reference Id not available.';
    }
  }); //End of filter declaration;